import { ALLOWED_FILE_EXTENSIONS, MAX_FILE_BYTES } from "../constants"

const FALLBACK_MIME_BY_EXTENSION = {
  ".pdf": "application/pdf",
  ".txt": "text/plain",
  ".log": "text/plain",
  ".csv": "text/csv",
  ".md": "text/markdown",
  ".json": "application/json",
  ".zip": "application/zip",
  ".gz": "application/gzip",
  ".tar": "application/x-tar",
}

export function validateFileClientSide(file) {
  const ext = "." + (file.name.split(".").pop() ?? "").toLowerCase()
  if (!ALLOWED_FILE_EXTENSIONS.includes(ext)) {
    return `File type ${ext || "(no extension)"} not allowed`
  }
  if (file.size > MAX_FILE_BYTES) {
    return "File too large (max 8 MB)"
  }
  return null
}

export function readFileAsDataUri(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const ext = "." + (file.name.split(".").pop() ?? "").toLowerCase()
      const fallbackMime = FALLBACK_MIME_BY_EXTENSION[ext]
      const result = String(reader.result || "")
      resolve(result.startsWith("data:;base64,") && fallbackMime
        ? result.replace("data:;base64,", `data:${fallbackMime};base64,`)
        : result)
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}

export function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return ""
  if (bytes < 1024) return bytes + " B"
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " KB"
  return (bytes / (1024 * 1024)).toFixed(1) + " MB"
}
